import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IInteractionType, IImage } from '../../interfaces/definitions';
import { StoreService } from '../../services/store.service';
import { Storage } from '../../services/storage';
import { UtilsService } from '../../services/utils.service';
import { setTranslationKeys } from '../../translations';
import { NgMediaConfigService } from '../../services/ng-media-config.service';

@Component({
  selector: 'ng-media',
  templateUrl: './ng-media.component.html',
  styleUrls: ['./ng-media.component.scss']
})
export class NgMediaComponent implements OnInit {
  @Input() public type: 'single' | 'multiple' | 'editor' = 'editor';
  @Input() public enableUpload = true;
  @Input() public fileViewer = true;
  @Input() public folder = '';
  @Input() public maxFileSize = null;
  @Input() public allowedFormats = ['*'];
  @Input() public set apiPrefix(value) {
    this.config.API.next(value);
  }
  @Input() public parseContent = false;
  @Output() public selectionChange: EventEmitter<
    Array<IImage>
  > = new EventEmitter();
  @Output() public eventChange;
  @Output() public imageDelete;
  @Output() public uploadFinish: EventEmitter<any> = new EventEmitter();
  @Input() public translations = null;

  public storage: Storage = null;

  constructor(
    private store: StoreService,
    private utils: UtilsService,
    private config: NgMediaConfigService
  ) {
    this.storage = this.store.CreateStorage();
    this.eventChange = this.utils.eventChange;
    this.imageDelete = this.utils.deleteItem;
  }

  public updateSelection(items: Array<IImage> = []) {
    this.selectionChange.emit(items);
  }

  ngOnInit() {
    if (this.translations) {
      setTranslationKeys(this.translations);
    }
    this.storage.Folder.next(this.folder);
  }
  /**
   * @description It will reset all images inside this gallery. If you provide an array of items,
   * they will be replaced.
   */
  public ResetItems(items: Array<IImage> = []) {
    this.storage.ResetItems(items);
  }

  public GetStorage(): Storage {
    return this.storage;
  }

  public GetInteractionType(
    type: 'single' | 'multiple' | 'editor'
  ): IInteractionType {
    if (type === 'editor') {
      return IInteractionType.Edit;
    }
    if (type === 'multiple') {
      return IInteractionType.MultipleSelect;
    }
    if (type === 'single') {
      return IInteractionType.SingleSelect;
    }
    return null;
  }
}
